import {
	Button,
	Col,
	DatePicker,
	Form,
	Icon,
	Input,
	Popover,
	Row,
	Select,
	Spin,
	Switch,
	Table,
	Tabs,
	Upload,
} from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout, getRequiredRule, getStringSorter } from '../utils/antUtils';
import { ENV } from '../utils/http';
import { getPageSize } from '../utils/paging';
import styles from './sbl.css';
import {
	fetchRegisters,
	deleteAttachment,
	updateLegalCommentDates,
	deleteLawDocument,
	edit,
	fetchSbl,
	onChangeTab,
	save,
	showEmailDialog,
} from './sblActions';

import SblEmailModalComponent from './sblEmailModalComponent';

const { Column } = Table;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const { TextArea } = Input;

class SblComponent extends Component {
	state = {
		confirmDeleteVisible: false,
		selectedRowKeys: [],
		register_options: [],
	};

	componentDidMount() {
		this.props.dispatch(fetchSbl(this.props.match.params.id));
		this.props.dispatch(fetchRegisters()).then(() => {
			this.setState({ register_options: this.props.registers });
		});
	}

	componentDidUpdate() {
		if (this.props.id !== -1 && this.props.id != this.props.match.params.id) {
			this.props.dispatch(fetchSbl(this.props.match.params.id));
		}
	}

	onChange(event, attr) {
		this.props.dispatch(edit(attr, event.target.value));
	}

	onChangeValue(value, attr) {
		this.props.dispatch(edit(attr, value));
	}

	preview() {
		window.open(`${ENV.previewUrl}/lag/${this.props.id}`, '_blank');
	}

	editSba() {
		window.open(`/lagdel/lag/${this.props.id}/andringar`, '_blank');
	}

	showSendEmail() {
		let selectedEntries = this.props.watchListEntries.filter(
			(we) => this.state.selectedRowKeys.indexOf(we.key) >= 0
		);
		const emails = new Set();
		let ids = [];

		selectedEntries.forEach((e) => {
			e.emails.forEach((email) => {
				emails.add(email);
			});

			ids.push(e.id);
		});

		// lastChanged, subject, content

		let lastChanged = moment().format('YYYY-MM-DD');
		const subject = `Infosoc Lagbevakning - ${this.props.title} (${this.props.sfsNumber}) har ändrats ${lastChanged}`;
		const content = `Ändringen innebär att…
  
Länk till lag:
${ENV.previewUrl}/lag/${this.props.id}
  
Länk till ändring:
${ENV.previewUrl}/lag/${this.props.id}/andringar
Med vänliga hälsningar,

Infosoc Rättsdata AB`;

		this.props.dispatch(showEmailDialog(ids, Array.from(emails), lastChanged, subject, content));
	}

	onSelectChange = (selectedRowKeys) => {
		this.setState({ selectedRowKeys });
	};

	render() {
		const { getFieldDecorator } = this.props.form;
		const textAreaRows = 25;

		let fileList = this.props.attachments
			? this.props.attachments.map((a) => ({
					uid: a.id,
					name: a.name,
					url: `${ENV.url}/attachment/${a.id}`,
					thumbUrl: '',
			  }))
			: [];

		let { dispatch } = this.props;

		const uploadProps = {
			action: `${ENV.url}/admin/lawdocuments/attachments/upload?id=${this.props.id}`,
			className: 'upload-list-inline',
			onRemove(file) {
				dispatch(deleteAttachment(file.originFileObj ? file.originFileObj.uid : file.uid));
			},
			onChange(info) {
				if (info.file.status === 'done') {
					info.file.originFileObj.uid = info.file.response.id;
				}
			},
			defaultFileList: fileList,
		};

		const rowSelection = {
			selectedRowKeys: this.state.selectedRowKeys,
			onChange: this.onSelectChange,
		};

		let confirmPopup = (
			<div>
				<Button onClick={() => this.props.dispatch(deleteLawDocument(this.props.id))}>Ja</Button>
				<Button
					style={{ marginLeft: 10 }}
					onClick={() => this.setState({ confirmDeleteVisible: false })}
				>
					Nej
				</Button>
			</div>
		);

		const showSave = parseInt(this.props.activeTab) < 3;

		return (
			<div>
				<SblEmailModalComponent />

				<div style={styles.toolbar}>
					{showSave && (
						<Button
							type='primary'
							style={{ float: 'right', marginTop: 10 }}
							size='large'
							onClick={() => this.props.dispatch(save(this.props))}
						>
							Spara
						</Button>
					)}
					<Button
						icon='search'
						style={{ float: 'right', marginTop: 10, marginRight: 10 }}
						size='large'
						type='secondary'
						onClick={() => this.preview()}
					>
						Förhandsgranska
					</Button>
					<Popover
						visible={this.state.confirmDeleteVisible}
						placement='topLeft'
						title={'Är du säker?'}
						content={confirmPopup}
						trigger='click'
					>
						<Button
							style={{ float: 'right', marginTop: 10, marginRight: 10 }}
							size='large'
							type='danger'
							onClick={() => this.setState({ confirmDeleteVisible: true })}
						>
							Radera
						</Button>
					</Popover>
				</div>
				<Row style={{ marginTop: 20 }}>
					<Spin spinning={this.props.loading}>
						<Col span={24}>
							<Tabs
								activeKey={this.props.activeTab}
								onChange={(activeTab) => this.props.dispatch(onChangeTab(activeTab))}
							>
								<TabPane tab='Grunduppgifter' key={'1'}>
									<Form onSubmit={this.handleSubmit} style={{ maxWidth: 900 }}>
										<FormItem {...formItemLayout} label='Publicerad till kund'>
											{getFieldDecorator('published', { valuePropName: 'checked' })(
												<Switch onChange={(e) => this.onChangeValue(e, 'published')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Titel'>
											{getFieldDecorator('title', { rules: [getRequiredRule('Ange en titel')] })(
												<Input style={{ fontSize: 20 }} onBlur={(e) => this.onChange(e, 'title')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Register'>
											{getFieldDecorator('register', {
												rules: [getRequiredRule('Ange ett register')],
											})(
												<Select
													style={{ width: '100%' }}
													showSearch
													optionFilterProp='children'
													onChange={(e) => this.onChangeValue(e, 'register')}
												>
													{this.state.register_options.map((r) => (
														<Option key={r.id} value={r.id}>
															{r.name}
														</Option>
													))}
												</Select>
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Produktionsbeteckning'>
											{getFieldDecorator('originalFileName', {
												rules: [getRequiredRule('Ange en Produktionsbeteckning')],
											})(<Input onBlur={(e) => this.onChange(e, 'originalFileName')} />)}
										</FormItem>
										<FormItem {...formItemLayout} label='Extern webblänk'>
											{getFieldDecorator('externalWeblink')(
												<Input onBlur={(e) => this.onChange(e, 'externalWeblink')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Förkortning'>
											{getFieldDecorator('abbreviation')(
												<Input onBlur={(e) => this.onChange(e, 'abbreviation')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='SFS-Nummer'>
											{getFieldDecorator('sfsNumber')(
												<Input onBlur={(e) => this.onChange(e, 'sfsNumber')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Förarbeten'>
											{getFieldDecorator('preparation')(
												<Input onBlur={(e) => this.onChange(e, 'preparation')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Databaser'>
											{getFieldDecorator('databases')(
												<Input onBlur={(e) => this.onChange(e, 'databases')} />
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Ikraftträdande'>
											{getFieldDecorator('introductionDate')(
												<DatePicker
													onChange={(e) => this.props.dispatch(edit('introductionDate', e))}
													format='YYYY-MM-DD'
												/>
											)}
										</FormItem>
										<FormItem {...formItemLayout} label='Sammanfattning'>
											{getFieldDecorator('summary')(
												<TextArea rows={textAreaRows} onBlur={(e) => this.onChange(e, 'summary')} />
											)}
										</FormItem>
									</Form>
								</TabPane>
								<TabPane tab='Lagtext' key={'2'}>
									<FormItem>
										{getFieldDecorator('content')(
											<TextArea
												style={styles.textArea}
												rows={textAreaRows}
												onBlur={(e) => this.onChange(e, 'content')}
											/>
										)}
									</FormItem>
								</TabPane>
								<TabPane tab='Bilagor' key={'3'}>
									{!this.props.loading && (
										<Upload {...uploadProps}>
											<Button>
												<Icon type='upload' /> Ladda upp
											</Button>
										</Upload>
									)}
								</TabPane>
								<TabPane tab={`Ändringar (${this.props.changeHistory.length})`} key={'4'}>
									<Button onClick={() => this.editSba()}>
										<Icon type='edit' /> Redigera ändringsfil
									</Button>
									<div
										style={styles.sbaDocument}
										dangerouslySetInnerHTML={{ __html: this.props.sbaDocument }}
									/>
								</TabPane>
								<TabPane tab={`Bevakningar (${this.props.watchListEntries.length})`} key={'5'}>
									<Row style={{ marginBottom: 20 }}>
										<Button
											disabled={this.state.selectedRowKeys.length === 0}
											onClick={() => this.showSendEmail()}
										>
											<Icon type='mail' /> Skicka e-post
										</Button>
									</Row>

									<Table
										rowSelection={rowSelection}
										className='large-padding-table'
										dataSource={this.props.watchListEntries}
										size='small'
										pagination={{ pageSize: getPageSize(), position: 'bottom' }}
									>
										<Column
											width={350}
											title='Kund'
											dataIndex='customer'
											key='customer'
											sorter={getStringSorter('customer')}
										/>
										<Column
											width={250}
											defaultSortOrder='descend'
											title='Paragraf'
											dataIndex='link'
											key='link'
											sorter={getStringSorter('link')}
										/>
										<Column
											title='E-post'
											render={(value, record, index) => (
												<div>
													{record.emails.map((e) => (
														<div>{e}</div>
													))}
												</div>
											)}
										/>
									</Table>
								</TabPane>
								<TabPane tab={`Lagkommentarer`} key={'6'}>
									Klicka på knappen nedan för att uppdatera beslutsdatumet till dagens datum på alla
									lagkommentarer för denna lagen.
									<div style={{ marginTop: 20 }}>
										<Button
											onClick={() => this.props.dispatch(updateLegalCommentDates(this.props.id))}
										>
											Uppdatera bestlutsdatum
										</Button>
									</div>
								</TabPane>
							</Tabs>
						</Col>
					</Spin>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: state.sbl.loading,
	id: state.sbl.id,
	title: state.sbl.title,
	content: state.sbl.content,
	register: state.sbl.register,
	databases: state.sbl.databases,
	summary: state.sbl.summary,
	introductionDate: state.sbl.introductionDate,
	abbreviation: state.sbl.abbreviation,
	sfsNumber: state.sbl.sfsNumber,
	originalFileName: state.sbl.originalFileName,
	preparation: state.sbl.preparation,
	published: state.sbl.published,
	externalWeblink: state.sbl.externalWeblink,
	registers: state.sbl.registers,
	introductionDate: state.sbl.introductionDate,
	attachments: state.sbl.attachments,
	changeHistory: state.sbl.changeHistory,
	sbaDocument: state.sbl.sbaDocument,
	activeTab: state.sbl.activeTab,
	watchListEntries: state.sbl.watchListEntries,
});

export default connect(mapStateToProps)(
	Form.create({
		mapPropsToFields(props) {
			return {
				title: Form.createFormField({ value: props.title }),
				content: Form.createFormField({ value: props.content }),
				register: Form.createFormField({ value: props.register }),
				databases: Form.createFormField({ value: props.databases }),
				introductionDate: Form.createFormField({ value: props.introductionDate }),
				abbreviation: Form.createFormField({ value: props.abbreviation }),
				sfsNumber: Form.createFormField({ value: props.sfsNumber }),
				originalFileName: Form.createFormField({ value: props.originalFileName }),
				preparation: Form.createFormField({ value: props.preparation }),
				published: Form.createFormField({ value: props.published }),
				externalWeblink: Form.createFormField({ value: props.externalWeblink }),
				registers: Form.createFormField({ value: props.registers }),
				introductionDate: Form.createFormField({ value: moment(props.introductionDate) }),
				summary: Form.createFormField({ value: props.summary }),
			};
		},
	})(SblComponent)
);



// WEBPACK FOOTER //
// ./src/sbl/sblComponent.js